import { Typography } from '@lingoda/ui';

interface SectionTitleProps {
    title: string;
}

export const SectionTitle = ({ title }: SectionTitleProps) => (
    <Typography variant="h2">{title}</Typography>
);
